import { CotalkerApi } from "../functions/api";
import {COTAnswer, COTChannel, COTMessage, COTSurvey, COTTask} from "./COTTypes";

const ObjectId = (x: any) => x;
const ISODate = (x?: string): Date => x ? new Date(x) : new Date();
const NumberInt = (x: any) => x;

export class COTContextBuilder {
    headers: any;
    api: CotalkerApi;

    constructor(baseURL: string, headers: any) {
        this.headers = headers;
        this.api = new CotalkerApi(baseURL);

    }

    public async task(): Promise<COTTask> {

        const editors = Array(Math.round(Math.random() * 3) + 1).fill(1).map(() => this.randObjectId());
        const followers = Array(Math.round(Math.random() * 3) + 1).fill(1).map(() => this.randObjectId());
        const visibility = Array(Math.round(Math.random() * 3) + 1).fill(1).map(() => this.randObjectId());
        const userList = editors.concat(followers).concat(visibility);

        return {
            "_id" : ObjectId(this.randObjectId()),
            "answers" : [this.randObjectId()],
            "indentation" : NumberInt(1),
            "isActive" : true,
            "isValid" : false,
            "activeSlas" : [],
            "validators" : [],
            editors,
            followers,
            visibility,
            userList,
            "color" : "none",
            "formMessage" : [],
            "name" : this.randCode(),
            "relativeWeight" : NumberInt(1),
            "assignee" : ObjectId(this.randObjectId()),
            "parent" : null, // ObjectId(this.randObjectId()),
            "info" : this.randCode(),
            "createdBy" : ObjectId(this.randObjectId()),
            "company" : ObjectId(this.randObjectId()),
            "taskGroup" : ObjectId(this.randObjectId()),
            "owner" : "sample",
            "weight" : this.getRandomInt(0, 10000000000000),
            "status" : ObjectId(this.randObjectId()),
            "smState" : ObjectId(this.randObjectId()),
            "smStateMachine" : ObjectId(this.randObjectId()),
            "modifiedStateAt" : ISODate(),
            "closedAt" : null,
            "asset" : ObjectId(this.randObjectId()),
            "channelType" : "bound",
            "projectCode" : ObjectId(this.randObjectId()),
            "channel" : this.randObjectId(),
            "serial" : this.getRandomInt(1, 1000),
            "createdAt" : ISODate(),
            "modifiedAt" : ISODate(),
            "__v" : NumberInt(0),
            "endDate" : ISODate(),
            "estimatedTime" : ISODate(),
            "startDate" : ISODate(),
            "status1" : this.randObjectId(),
            "status2" : this.randObjectId(),
            "status3" : this.randObjectId(),
            "status4" : this.randObjectId(),
            "status5" : this.randObjectId(),
        };
    }

    private flat(input: any) {
        return input.flat(10)
    }

    public async messages(targetSurveyId: string, channelId: string): Promise<COTMessage[]> {
        const survey: COTSurvey = await this.api.getSurveyById(targetSurveyId, this.headers) as any
        const uuid = this.randObjectId();
        const formId = this.randObjectId();
        const data = survey.chat.map(c => {
            return {
                "form": {
                    "modifiedAt": [ISODate()],
                    "id": formId,
                    "createdAt": ISODate()
                },
                "content": "",
                "contentArray": c.contentArray.map(q => q._id),
                "isActive": c.isActive,
                "_id": this.randObjectId(),
                "contentType": "application/vnd.cotalker.survey",
                "modifiedAt": ISODate(),
                "channel": channelId,
                "answer": `${uuid}#${targetSurveyId}`,
                "sentBy": this.randObjectId(),
                "isSaved": 16,
                "createdAt": new Date().getTime(),
                "responses": c.contentArray.map(q => {
                    const dummy = this.build(q.contentType)
                    return {
                        cdata: dummy.responses,
                        cref: q._id,
                    };
                }),
                "readBy": []
            }
        });

        return (this.flat(data) as any);
    }

    public async message (content: string, sentBy?: string, channelId?: string): Promise<COTMessage> {
        return {
            "_id": ObjectId(this.randObjectId()),
            "form": {
                "modifiedAt": []
            },
            "cmd": {
                "ids": []
            },
            "content": "/giphy test",
            "contentArray": [],
            "isActive": true,
            "contentType": "text/plain",
            "channel": ObjectId(this.randObjectId(sentBy)),
            "modifiedAt": ISODate(),
            "sentBy": ObjectId(this.randObjectId(channelId)),
            "createdAt": new Date().getTime(),
            "isSaved": NumberInt(16),
            "responses": [],
            "readBy": []
        }
    }

    public async channel(): Promise<COTChannel> {
        return {
            "_id" : ObjectId(this.randObjectId()),
            "overrideName" : true,
            "nameCode" : "sample_channel",
            "nameDisplay" : "Sample Channel",
            "groupNumber" : NumberInt(0),
            "group" : ObjectId(this.randObjectId()),
            "company" : ObjectId(this.randObjectId()),
            "search" : [
                "sample",
                "channel"
            ],
            "autocomplete" : [

            ],
            "bots" : [

            ],
            "modifiedAt" : ISODate("2020-10-01T19:14:31.769+0000"),
            "createdAt" : ISODate("2017-08-11T22:36:24.667+0000"),
            "settings" : {
                "display" : "normal",
                "read" : "all",
                "write" : "all",
                "readUserIds" : [

                ],
                "writeUserIds" : [

                ]
            },
            "visibility" : {
                "users" : [

                ],
                "groupRoles" : [

                ],
                "all" : false
            },
            "isActive" : true,
            "isDirect" : false,
            "isPrivate" : true,
            "groupOwnerIds" : [
                ObjectId(this.randObjectId()),
            ],
            "archive" : [

            ],
            "userIds" : [
                ObjectId(this.randObjectId()),
                ObjectId(this.randObjectId()),
            ],
            "lightProperty" : [

            ],
            "propertyIds" : [
                ObjectId(this.randObjectId())
            ],
            "__v" : NumberInt(1),
            "image" : {
                "small" : "https://www.cotalker.com/api/users/200/sc/6054b6889297b9000841a85e/kx.png",
                "original" : "https://www.cotalker.com/api/users/400/sc/6054b6889297b9000841a85e/kx.png",
                "square" : "https://www.cotalker.com/api/users/300/sc/6054b6889297b9000841a85e/kx.png"
            },
            "info" : {
                "action" : [

                ],
                "properties" : [

                ],
                "startDate" : ISODate(),
                "users" : [

                ]
            },
            "pinned" : [
                ObjectId(this.randObjectId()),
            ],
            "lastMessage" : {
                "content" : "Last sample message",
                "date" : ISODate(),
                "sender" : ObjectId(this.randObjectId()),
                "contentType" : "text/plain"
            },
            "videoCall" : {
                "duration" : [

                ],
                "isActive" : false,
                "publishAudio" : [

                ],
                "publishVideo" : [

                ],
                "start" : {
                    "any" : false,
                    "permissions" : [

                    ]
                }
            },
            "actionButton" : [

            ]
        };
    }

    public async answer(surveyTargetId: string): Promise<COTAnswer> {
        const survey: COTSurvey = await this.api.getSurveyById(surveyTargetId, this.headers) as any

        const data = survey.chat.map(c => {
            return c.contentArray.map(q => {
                const dummy = this.build(q.contentType);
                return {
                    "code" : [],
                    "display" : q.display,
                    responses: dummy.responses,
                    process: dummy.process,
                    "_id" : ObjectId(this.randObjectId()),
                    "user" : ObjectId(this.randObjectId()),
                    "question" : q._id,
                    "contentType" : q.contentType,
                    "identifier" : q.identifier,
                    "diff" : []
                }
            });
        });

        return {
            "_id" : ObjectId(this.randObjectId()),
            "score" : { "scores" : [] },
            "isAuto" : true,
            "properties" : [
                ObjectId(this.randObjectId())
            ],
            "propertyTypes" : [
                this.randCode()
            ],
            "propertiesNeeded" : [],
            "identifiersNeeded" : [],
            "extendsAnswer" : [],
            "rExtendsAnswer" : [],
            "data" : (this.flat(data) as any),
            "uuid" : this.randObjectId(),
            "survey" : ObjectId(surveyTargetId),
            "company" : ObjectId(this.randObjectId()),
            "user" : ObjectId(this.randObjectId()),
            "createdAt" : ISODate(),
            "startDate" : ISODate(),
            "modifiedAt" : ISODate(),
            "target" : null,
            "channel" : ObjectId(this.randObjectId()),
            "__v" : NumberInt(0)
        };
    }

    private build (contentType: string): { responses: string[], process: string[] } {
        const responses = [];
        const process = [];
        switch (contentType) {
            case 'application/vnd.cotalker.survey+survey':
                // do nothiing?
                break;
            case 'application/vnd.cotalker.survey+text':
                // do nothing
                break;

            case 'application/vnd.cotalker.survey+textnumber':
                responses.push(String(this.getRandomInt(1, 100)));
                process.push(String(this.getRandomInt(1, 100)));
                break;

            case 'application/vnd.cotalker.survey+datetime':
                responses.push("2021-01-01");
                responses.push("11:11");
                process.push(String(new Date().getTime()));
                break;

            case 'application/vnd.cotalker.survey+property':
            case 'application/vnd.cotalker.survey+person':
                responses.push(JSON.stringify({_id: this.randObjectId()}));
                process.push(this.randObjectId());
                break;

            case 'application/vnd.cotalker.survey+listquestion':
            // break;
            case 'application/vnd.cotalker.survey+textinput':
            // break;
            case 'application/vnd.cotalker.survey+gps':
            // break;
            case 'application/vnd.cotalker.survey+image':
            // break;
            case 'application/vnd.cotalker.survey+signature':
            // break;
            case 'application/vnd.cotalker.survey+file':
            // break;
            case 'application/vnd.cotalker.survey+api':
            // break;
            default: // TODO Depends on data type.
                responses.push(this.randCode());
                process.push(this.randCode());
        }

        return { responses, process };
    }

    private hex = (input: number): string => Math.round(input)
        .toString(16)
        .toLocaleLowerCase()

    // Create dummy objectId based on date + random
    private randObjectId (staticId?: string) {
        if (staticId && staticId.length === 24) {
            return staticId;
        }

        const now = this.hex(new Date().getTime() / 1000);
        const rand = Array(16)
            .fill(1)
            .map(() => this.hex(Math.random() * 16)[0])
            .join('');

        return now + rand;
    };

    private randaz (length: number): string {
        // a = 10, z = 36
        return new Array(length)
            .fill(1)
            .map(()=> (Math.round(Math.random() * 26) + 10).toString(36))
            .join('')
    }

    private getRandomInt (min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    private randCode () {
        return `${this.randaz(8)}_${this.randaz(12)}`;
    }

}
